// @flow @format
import DownloadHistory from '../components/DownloadHistory';
import {
	deleteDownload,
	saveDownload,
	startDownload,
	pauseDownload,
} from '../reducers/entities/downloads';
import {toggleHistory} from '../reducers/history';
import {connect} from 'react-redux';
import * as dwl from 'lib/downloader';

import type {State} from '../reducers';

const emptyArray = [];

const mapStateToProps = (state: State) => {
	const filesActive = [];
	const filesFinished = [];

	const foldersActive = [];
	const foldersFinished = [];

	for (const id of Object.keys(state.entities.downloads.entities)) {
		const download = state.entities.downloads.entities[id];

		if (download.isFile) {
			if (download.status === dwl.DOWNLOAD_COMPLETED_STATUS) {
				filesFinished.push(download);
				continue;
			}

			filesActive.push(download);
			continue;
		}

		if (download.status === dwl.DOWNLOAD_COMPLETED_STATUS) {
			foldersFinished.push(download);
			continue;
		}

		foldersActive.push(download);
	}

	return {
		visible: state.history.visible,
		usedBytes: state.entities.downloads.usedBytes,
		grantedBytes: state.entities.downloads.grantedBytes,
		throughput: state.entities.downloads.throughput,

		activeFileDownloads:
			filesActive.length > 0
				? filesActive.sort((lhs, rhs) => lhs.createdAt - rhs.createdAt)
				: emptyArray,
		finishedFileDownloads:
			filesFinished.length > 0
				? filesFinished.sort(
						(lhs, rhs) => rhs.updatedAt - lhs.updatedAt
					)
				: emptyArray,
		activeFolderDownloads:
			foldersActive.length > 0
				? foldersActive.sort(
						(lhs, rhs) => lhs.createdAt - rhs.createdAt
					)
				: emptyArray,
		finishedFolderDownloads:
			foldersFinished.length > 0
				? foldersFinished.sort(
						(lhs, rhs) => rhs.updatedAt - lhs.updatedAt
					)
				: emptyArray,
	};
};

const mapDispatchToProps = {
	toggleHistory,
	deleteDownload,
	startDownload,
	saveDownload,
	pauseDownload,
};

export default connect(mapStateToProps, mapDispatchToProps)(DownloadHistory);



// WEBPACK FOOTER //
// ./src/containers/DownloadHistoryContainer.js